import { isNil, isNotNil } from "@etudescarre/utils";
import { Handshake as HandshakeIcon } from "@phosphor-icons/react";
import { apiClient } from "@/lib/api/client";
import {
  type PendingDispatchFetchArgs,
  type PendingDispatchPayload,
  PendingDispatchScreen,
} from "./pending-dispatch-screen";

async function fetchRemisesEnMainPropre({
  yardId,
  target,
  recipientTeamId,
}: PendingDispatchFetchArgs): Promise<PendingDispatchPayload> {
  const { data, error } = await apiClient.GET(
    "/api/yards/{yardId}/remises-en-main-propre",
    {
      params: {
        path: { yardId },
        query: {
          target,
          ...(isNotNil(recipientTeamId) ? { recipientTeamId } : {}),
        },
      },
    },
  );

  if (error || isNil(data)) {
    throw new Error("Erreur lors du chargement des remises en main propre");
  }
  return data.data;
}

/**
 * Écran 021bis — « Préparer et enregistrer les remises en main propre ».
 * Fin habillage de l'écran partagé : file des remises en main propre en attente
 * (`transmission.modeEnvoi = en_main_propre` sans `dateEnvoi`). Affiche en plus
 * la colonne « Formats » (natif / PDF réellement transmis).
 */
export function RemisesEnMainPropre() {
  return (
    <PendingDispatchScreen
      title="Préparer et enregistrer les remises en main propre"
      errorLabel="Erreur lors du chargement des remises en main propre"
      emptyLabel="Aucune remise en main propre en attente"
      pendingColumnLabel="Remises en attente"
      pendingIcon={HandshakeIcon}
      tabBadgeTitle={(count) =>
        count > 0
          ? `${count} bordereau(x) à remettre en main propre`
          : "Aucune remise en main propre en attente"
      }
      showFormats
      fetchItems={fetchRemisesEnMainPropre}
    />
  );
}
